import { useCallback } from 'react';
import { bridge, getNumberRange } from 'shared/src/utils';
import { useLogMarketAnalyticsEvent } from './useLogMarketAnalyticsEvent';

export type RecommendedMarketAnalyticsTarget = {
  sno: number;
  name: string;
  favorites_count: number;
  market_type: { name: string };
  age_tags: string[];
  style_tags: string[];
};

export const useLogClickFavoriteMarket = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback<(isUnFavorite: boolean) => void>(
    isUnFavorite => {
      logMarketAnalytics({
        name: isUnFavorite
          ? 'CLICK_UNFAVORITE_MARKET'
          : 'CLICK_FAVORITE_MARKET',
      });
    },
    [logMarketAnalytics],
  );
};

export const useLogClickFavoriteRecommendedMarket = (
  market: RecommendedMarketAnalyticsTarget,
) => {
  return useCallback<(isUnFavorite: boolean) => void>(
    isUnFavorite => {
      bridge.logAnalyticsEvent({
        name: isUnFavorite
          ? 'CLICK_UNFAVORITE_MARKET'
          : 'CLICK_FAVORITE_MARKET',
        channel: ['firebase', 'facebook', 'amplitude', 'braze', 'ablylog'],
        analytics: {
          SCREEN: 'MARKET',
          MARKET_SNO: market.sno.toString(),
          MARKET_NAME: market.name,
          FAVORITE_COUNT: market.favorites_count,
          FAVORITE_COUNT_RANGE: getNumberRange({
            rangeUnit: 500,
            target: market.favorites_count,
          }),
          MARKET_TYPE: market.market_type.name,
          AGE_TAG1: market.age_tags[0],
          AGE_TAG2: market.age_tags[1],
          STYLE_TAG1: market.style_tags[0],
          STYLE_TAG2: market.style_tags[1],
        },
      });
    },
    [market],
  );
};
